// get element attribute for given name
// check for different names depending on integration
export function getDataAttribute(element, attributeName) {
  return (
    element.getAttribute(`data-omq-${attributeName}`) ||
    element.getAttribute(`data-userlike-${attributeName}`) ||
    element.getAttribute(`data-mapp-${attributeName}`) ||
    null
  );
}

// get element attribute for given name
// check for different names depending on integration
export function setDataAttribute(element, attributeName, value) {
  // userlike
  if (element.hasAttribute(`data-userlike-${attributeName}`)) {
    element.setAttribute(`data-userlike-${attributeName}`, value);
  }
  // mapp
  else if (element.hasAttribute(`data-mapp-${attributeName}`)) {
    element.setAttribute(`data-mapp-${attributeName}`, value);
  }
  // omq
  else {
    element.setAttribute(`data-omq-${attributeName}`, value);
  }
}